import { protectedRequest } from '@/api/protectedRequest'
import http from '@/api/http'
import { mapPersonalReferral } from '@/entities/referral/model/mapPersonalReferral'

function toNullableText(value) {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  const trimmed = String(value).trim()
  return trimmed === '' ? null : trimmed
}

export async function fetchPersonalProfileApi(userId) {
  if (!userId) {
    return null
  }
  const payload = await protectedRequest(() => http.get(`/personal/get/${userId}`))
  return payload.data ?? null
}

export async function updatePersonalProfileApi({
  firstName,
  lastName,
  phoneNumber,
  defaultAddress,
  defaultAddressSubtitle,
  location,
} = {}) {
  const body = {}

  if (firstName !== undefined) {
    body.first_name = toNullableText(firstName)
  }
  if (lastName !== undefined) {
    body.last_name = toNullableText(lastName)
  }
  if (phoneNumber !== undefined) {
    body.phone_number = toNullableText(phoneNumber)
  }
  if (defaultAddress !== undefined) {
    body.default_address = toNullableText(defaultAddress)
  }
  if (defaultAddressSubtitle !== undefined) {
    body.default_address_subtitle = toNullableText(defaultAddressSubtitle)
  }
  if (location !== undefined) {
    body.location = location
  }

  if (!Object.keys(body).length) {
    throw new Error('profile_update_empty')
  }

  const payload = await protectedRequest(() => http.patch('/personal/profile', body))
  return payload.data ?? null
}

export async function checkTelegramLinkApi() {
  const payload = await protectedRequest(() => http.post('/personal/links/telegram/check'))
  return payload
}

export async function fetchPersonalReferralApi() {
  const payload = await protectedRequest(() => http.get('/personal/referral'))
  return mapPersonalReferral(payload.data)
}

export async function claimPersonalReferralQrApi(code) {
  const payload = await protectedRequest(() =>
    http.post('/personal/referral/claim', { code }),
  )
  return payload.data ?? null
}
